import { render, staticRenderFns } from "./point-reward-rule.vue?vue&type=template&id=5f344950&scoped=true"
import script from "./point-reward-rule.vue?vue&type=script&lang=js"
export * from "./point-reward-rule.vue?vue&type=script&lang=js"
import style0 from "./point-reward-rule.vue?vue&type=style&index=0&id=5f344950&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f344950",
  null
  
)

export default component.exports